// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__DHVRP","inner":"styles_inner__ksuDq","row":"styles_row__GYuVw","total":"styles_total__UWHT9","fee":"styles_fee__Kq_BX"};